import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL_SOUSCRIRE_EN_LIGNE;

const getRappelConseiller = async () => {
  const response = await axios.get(`${apiBaseUrl}/rappel/get-jours`);
  if (!response) {
    throw new Error('Erreur de format de donnée: login service');
  }
  const data = await response.data;
  return data;
};

const useGetRappelConseiller = () => {
  return useQuery({
    queryKey: ['useGetRappelConseiller'],
    queryFn: getRappelConseiller,
  });
};

export { getRappelConseiller, useGetRappelConseiller };
